import { styled } from '@mui/material/styles';

import { Theme, rem } from '../../theme';
import { Paragraph } from '../Paragraph';

export const StyledCircle = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: ${theme.tggSpacing(rem(15), 37.5)};
        height: ${theme.tggSpacing(rem(15), 37.5)};
        padding: ${theme.tggSpacing([rem(1), rem(2), 0, rem(2)], [2.5, 5, 0, 5])};
        text-align: center;
        border: 3px solid #e5effa;
        border-radius: 50%;

        ${theme.breakpoints.up('desktop')} {
            width: ${theme.tggSpacing(rem(19), 47.5)};
            height: ${theme.tggSpacing(rem(19), 47.5)};
            padding: ${theme.tggSpacing([rem(1), rem(3), 0, rem(3)], [2.5, 7.5, 0, 7.5])};
        }
    `}
`;

export const StyledCount = styled('div')`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_40_bold_lh_20_desktop_54_lh_22};
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(1), 2.5)};

        ${theme.breakpoints.up('desktop')} {
            margin-bottom: ${theme.tggSpacing(rem(2), 5)};
        }
    `}
`;

export const StyledParagraph = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => theme.typography.bodyStandard};
`;
